

























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-trash',

})
export default class ITrash extends Vue {

  @Prop({type: [String], default: 'badge'}) protected type!: string
  @Prop({type: [String], default: '#2D9CDB'}) protected color!: string

}

